<template>
    <div></div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

    export default {
        name: "CompanySettings",
        data() {
            return {
                userData: this.$store.getters.getUserData,
            }
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Сервис", route: "company-settings"},
                {title: "Настройки РЭК"}
            ]);
        }
    }
</script>

<style scoped>

</style>